/**
 * @file 自定义列下拉组件
 * @author alfielv
 */
import React from 'react';
import classNames from 'classnames';
import { Icon } from '@tencent/spaui';

var OptionComponent = function OptionComponent(props) {
  var prefixCls = props.prefixCls,
      children = props.children,
      data = props.data,
      className = props.className,
      onClick = props.onClick,
      onDelete = props.onDelete,
      onEdit = props.onEdit;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__option")
  }, /*#__PURE__*/React.createElement("a", {
    className: classNames("".concat(prefixCls, "__option__label"), className),
    onClick: onClick
  }, children), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "__option__actions")
  }, /*#__PURE__*/React.createElement("a", {
    className: "".concat(prefixCls, "__option__icon"),
    "aria-label": "\u7F16\u8F91",
    onClick: function onClick() {
      return onEdit(data.value);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "edit-outlined"
  })), /*#__PURE__*/React.createElement("a", {
    className: "".concat(prefixCls, "__option__icon"),
    "aria-label": "\u5220\u9664",
    onClick: function onClick() {
      return onDelete(data.value);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "delete-outlined"
  }))));
};

export default OptionComponent;